/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';
import FBGroupModalGIF from 'app/components/GroupModal/FBGroupModalGIF.jsx';

class FacebookOutput extends React.Component {
    constructor(props) {
        super(props);

        this.checkGroupStatus = this.checkGroupStatus.bind(this);
    }


    checkGroupStatus(e) {
        if (e) {
            e.preventDefault();
        }

        let id = e.currentTarget.dataset.id,
            constants = this.props.app.config.constants;

        if (this.props.subtype === constants.FB_SUBTYPE_GROUP) {
            let subaccount = this.props.subaccounts.find((subaccount) => { return subaccount.id === id; });

            if (subaccount && subaccount.groupConnected === 0) {
                this.props.addModal(
                    <FBGroupModalGIF
                        {...this.props}
                        subaccount={subaccount}/>
                );
                this.props.toggleModal(true);
                this.props.toggleFooter(false);
            }
        }

    }

    render() {
        let serviceMessage = null,
            constants = this.props.app.config.constants,
            type = 'Page';

        if (this.props.subtype === constants.FB_SUBTYPE_GROUP) {
            serviceMessage = (
                <span>Connecting a Facebook Group? Additional step required — <a href="https://support.dlvrit.com/hc/en-us/articles/360007690813" target="_blank">Read More</a></span>
            );
            type = 'Group';
        }

        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy={`Select a Facebook ${type}`}
                    serviceMessage={serviceMessage}/>
                <ChooserMain
                    {...this.props}
                    buttonDecorator={this.checkGroupStatus}
                    ineligibleMessage={(
                        <div>
                            <p className="chooser-notice short-bottom">These socials are not eligible for posting.</p>
                            <p className="chooser-notice small">Facebook doesn't allow <a href="https://support.dlvrit.com/hc/en-us/articles/360007291174" target="_blank">3rd parties to post to profiles.</a> Facebook pages require <a href="https://www.facebook.com/help/289207354498410" target="_blank">specific permissions.</a></p>
                        </div>
                    )}/>
            </div>
        );
    }
}

FacebookOutput.displayName = "FacebookOutput";

export default FacebookOutput;
